import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import $ from "jquery";
import axios from "axios";
import 'bootstrap-daterangepicker/daterangepicker.css';
import {connect}  from  "react-redux";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, unauthorize_access, user_activities } from '../../helpers/utils.js';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import CityFilter from '../../filters/CityFilter.jsx';
import StateFilter from '../../filters/StateFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import DistinctValueFilter from '../../filters/DistinctValueFilter.jsx';
var date_config = date_range_config('1', '1', '2020-02-01','1');
var misTable='';

class MISReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantID:'',
            chainID:'',
            storeID:'',
            manufacturerIDs: [],
            manufacturerOptions: [],
            productCategoryIDs: [],
            productCategoryOptions: [],
            cityIDs:'',
            stateIDs:'',
            isChange: false,
            state_code:'',
            object_code:[],
        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        // isReportAccess(AllAccessPermissions, 'mis_report');
        isReportAccess(AllAccessPermissions, 'fund_transfer_settlement');
        if(decoded.object_type==='Merchant'){
            this.setState({ merchantID: arrayCode });
        }
        if(decoded.object_type==='Chain'){
            this.setState({ chainID: arrayCode });
        }
        if(decoded.object_type==='Store'){
            this.setState({ storeID: arrayCode });
        }
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
        if(decoded.userGroupName==='Meta Users')
        {
            if(decoded.object_type==='Innoviti')
            {
                var state_code = localStorage.state_code;
                if(state_code=='' || state_code=='null' || state_code==null || state_code==undefined) {
                    this.setState({ state_code: '' });
                } else {
                    var state_arr = state_code.split(",");
                    this.setState({ state_code: state_arr });
                }
            } else {
                unauthorize_access();
            }
        }
    }

    componentDidMount() {
        this.fetchFilterOptions();
        this.get_filtered_mis_report(this.state.object_type,this.state.object_code,'');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'mis_report','sparcs')
    }

    fetchFilterOptions() {
        axios.get(config.get('API_URL') + '/summaryReport/mis-manufacturer-options', {
            headers: { Authorization: ` ${localStorage.usertoken}` }
        }).then(response => {
            const data = (response.data && response.data.data) || {};
            this.setState({
                manufacturerOptions: Array.isArray(data.manufacturer) ? data.manufacturer : [],
                productCategoryOptions: Array.isArray(data.product_category) ? data.product_category : [],
            });
        }).catch(err => { console.log(err); });
    }

    downloadMisReportCheck(e){
        let filters = {
            store_codes: this.state.storeID,
            manufacturer: this.state.manufacturerIDs,
            product_category: this.state.productCategoryIDs,
            city_name: this.state.cityIDs,
            state_name: this.state.stateIDs,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            download: 1,
            state_code: this.state.state_code,
        };
        this.setState({ filters: filters });
        const noFilters = this.state.storeID === ''
            && (!this.state.manufacturerIDs || this.state.manufacturerIDs.length === 0)
            && (!this.state.productCategoryIDs || this.state.productCategoryIDs.length === 0)
            && this.state.cityIDs === '' && this.state.stateIDs === '';
        if (noFilters) {
            confirmAlert({
                message: "Do you really want to download all data for date range: " + this.state.datefromShow + " - " + this.state.dateToShow + " ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
                buttons: [{
                    label: 'OK',
                    onClick: () => {
                        this.refs.downloadAllReport.downLoadReport(filters, '/report/settlement/mis', 'mis_report', -1);
                    }
                },
                { label: 'Cancel' }
                ]
            });
        } else {
            this.refs.downloadAllReport.downLoadReport(filters, '/report/settlement/mis', 'mis_report', -1);
        }
    }

    get_filtered_mis_report(object_type, object_code, event) {
        var that = this;
        var stores = this.state.storeID;

        isApiResponse(false);

        if (object_type === 'Store' && this.state.storeID === '') { stores = object_code; }

        var postData = {
            sids: stores,
            manufacturer: this.state.manufacturerIDs,
            product_category: this.state.productCategoryIDs,
            city_name: this.state.cityIDs,
            state_name: this.state.stateIDs,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            state_code: this.state.state_code,
        };
        if ($.fn.DataTable.isDataTable('#misTable')) {
            $('#misTable').DataTable().clear().destroy();
        }
        misTable = $('#misTable').DataTable({
            order: [],
            "processing": true,
            "serverSide": true,
            "bDestroy": true,
            "paging": true,
            "pageLength": 20,
            "bInfo": false,
            "sPaginationType": "numbers",
            "responsive": false,
            "scrollX": false,
            "autoWidth": false,
            "lengthMenu": [[20, 50, 100, 500 - 1], [20, 50, 100, 500, "All"]],
            ajax: {
                url: config.get('API_URL') + "/summaryReport/mis-report",
                type: "POST",
                data: postData,
                dataSrc: function (json) {
                    isApiResponse(true);
                    that.setState({ isChange: false });
                    return json.data;
                },
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                error: function (data) {
                    isApiResponse(true);
                    alert("Failed to load data. Please try again");
                },
                complete: function (data) {
                    isApiResponse(true);
                },
            },
            columns: [
                {"data": "Credit_Debit"},
                {"data": "Acquirer"},
                {"data": "Manufacturer"},
                {"data": "Store_Name"},
                {"data": "City_Name"},
                {"data": "Store_State"},
                {"data": "Transaction_Date"},
                {"data": "Txn_Amount"},
                {"data": "Product_Category"},
                {"data": "Rate"},
                {"data": "EMI_Interest"},
                {"data": "Brand_Discount"},
            ],
            "columnDefs": [
                {
                    render: function (data, type, full, meta) {
                        if (data === null || data === '' || data === 'null') {
                            data = '';
                        }
                        return "<div class='text-wrap width-150'>" + data + "</div>";
                    },
                    "targets": [3]
                }
            ]
        });
    }

    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        if(this.state.object_type==='Innoviti')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
        }

        this.refs.cityFilter.resetCityFilter();
        this.refs.stateFilter.resetStateFilter();
        this.refs.manufacturerFilter.resetFilter();
        this.refs.productCategoryFilter.resetFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            storeID:'',
            manufacturerIDs: [],
            productCategoryIDs: [],
            cityIDs:'',
            stateIDs:'',
            isChange: false,
        });

        setTimeout(function(){
            this.componentWillMount();
            this.componentDidMount();
        }.bind(this), 200);
    }

    handleDateRange = (todSend, yestSend, datefromShow, dateToShow) => {
        this.setState({ todSend, yestSend, datefromShow, dateToShow, isChange: true });
    }
    handleStore = (storeID) => {
        this.setState({ storeID, isChange: true });
    }
    handleManufacturer = (manufacturerIDs) => {
        this.setState({ manufacturerIDs, isChange: true });
    }
    handleProductCategory = (productCategoryIDs) => {
        this.setState({ productCategoryIDs, isChange: true });
    }
    handleCity = (optionSelected, cityIDs) => {
        this.setState({ cityIDs, isChange: true });
    }
    handleState = (optionSelected, stateIDs) => {
        this.setState({ stateIDs, isChange: true });
    }

    render() {
        return (
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Brand MIS Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu"></div>
                                </div>
                                <div className="clearfix"></div>
                                <div className="content">
                                    <div className="row">
                                        <div className="col-md-12 filter-border-right" style={{display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start'}}>
                                            <div className="col-md-3 filter-bottom5 padd-5 date-icon-small">
                                                <div><label> Transaction Date: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate={this.handleDateRange} start_date={this.state.datefrom} end_date={this.state.dateTo} display_start_date={this.state.datefromShow} display_end_date={this.state.dateToShow}
                                                    start_date_limit={this.state.dateFromLimit} end_date_limit={this.state.dateLimit}/>
                                            </div>
                                            <div className="col-md-3 filter-bottom5 padd-5">
                                                <label> Manufacturer: </label>
                                                <DistinctValueFilter ref="manufacturerFilter" name="manufacturer" placeholder="All" options={this.state.manufacturerOptions} onSelect={this.handleManufacturer}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-3 filter-bottom5 padd-5">
                                                <label> Product Category: </label>
                                                <DistinctValueFilter ref="productCategoryFilter" name="product_category" placeholder="All" options={this.state.productCategoryOptions} onSelect={this.handleProductCategory}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-3 filter-bottom5 padd-5">
                                                <label> Store Name: </label>
                                                <StoreFilter ref="reloadStore" onSelectStore={this.handleStore} object_type={this.state.object_type} object_code={this.state.object_code} user_type={this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-3 filter-bottom5 padd-5">
                                                <label> City Name: </label>
                                                <CityFilter ref="cityFilter" onSelectCity={this.handleCity}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-3 filter-bottom5 padd-5">
                                                <label> State Name: </label>
                                                <StateFilter ref="stateFilter" onSelectstate={this.handleState} userType={this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange === true ?
                                                <span className="apply-notification">Please click on Apply button</span> : null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_mis_report.bind(this, this.state.object_type, this.state.object_code)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button" onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downloadMisReportCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width marginTop0">
                                        <table id="misTable" className="table table-striped table-hover" style={{width: '100%'}}>
                                            <thead>
                                            <tr>
                                                <th>Credit/Debit</th>
                                                <th>Acquirer</th>
                                                <th>Manufacturer</th>
                                                <th>Store Name</th>
                                                <th>City Name</th>
                                                <th>Store State</th>
                                                <th>Transaction Date</th>
                                                <th>Txn Amount</th>
                                                <th>Product Category</th>
                                                <th>Rate</th>
                                                <th>EMI Interest</th>
                                                <th>Brand Discount</th>
                                            </tr>
                                            </thead>
                                            <tbody></tbody>
                                        </table>
                                    </div>
                                    <DownloadAllReport ref="downloadAllReport" />

                                    <div className="footer">
                                        <div className="stats"><i></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        currentMenu: (name) => { dispatch({type:'change_menu',payload:name}) }
    }
};
export default connect(null, mapDispatchToProps)(MISReport);
